export default __webpack_public_path__ + "static/media/14-Apple Music.d03ba4fb.png";